import * as api from '../../services/brand/api_brand';
import { browserHistory } from 'react-router';
import { takeEvery, takeLatest, delay } from 'redux-saga/effects';
import { call, put, select } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListBrandSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_BRAND', callFetchListBrand, feathersApp);
}

function* callFetchListBrand(feathersApp, action) {
	const { silent, filters } = action;
	yield SagaCommon.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: DocType.BRAND
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield SagaCommon.showErrorListTable(error);
	}
}

export function* saveBrandSaga(feathersApp) {
	yield takeEvery("SAVE_BRAND", callSaveBrand, feathersApp);
}
function* callSaveBrand(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveBrand, feathersApp, params);
		yield SagaCommon.doneSaveRecord(result, 'Brand was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});		
		yield callFetchListBrand(feathersApp, { silent: true });

	} catch (e) {
		yield SagaCommon.showErrorSaveRecord(e);
	}
}

export function* deleteBrandFromListSaga(feathersApp) {
	yield takeEvery('DELETE_BRAND_FROM_LIST', callDeleteBrandFromList, feathersApp);
}

function* callDeleteBrandFromList(feathersApp, action) {
	yield deleteBrand(feathersApp, action);
	yield delay(2000);
	yield callFetchListBrand(feathersApp, { silent: true });
}

function* deleteBrand(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteBrand, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.BRAND } });
			yield callFetchListBrand(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteBrandSaga(feathersApp) {
	yield takeEvery('DELETE_BRAND', callDeleteBrand, feathersApp);
}

function* callDeleteBrand(feathersApp, action) {
	const result = yield deleteBrand(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/brand');
	}
}

export function* fetchBrandForEditSaga(feathersApp) {
	yield takeEvery('FETCH_BRAND_BY_ID', callFetchBrandForEdit, feathersApp);
}

function* callFetchBrandForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.BRAND;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchBrandById, feathersApp, fetchParams);
			yield SagaCommon.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});

		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
